export const combinedTextDecorationClass = '[text-decoration-line:underline_line-through]';

export type TextDecoration = 'underline' | 'line-through';

export function getTextDecorationState(value: string | null | undefined): {
  underline: boolean;
  strikethrough: boolean;
} {
  return {
    underline: value === 'underline' || value === combinedTextDecorationClass,
    strikethrough: value === 'line-through' || value === combinedTextDecorationClass,
  };
}

export function textDecorationClassForState(underline: boolean, strikethrough: boolean): string {
  if (underline && strikethrough) return combinedTextDecorationClass;
  if (underline) return 'underline';
  if (strikethrough) return 'line-through';
  return 'no-underline';
}

export function toggleTextDecorationClass(currentValue: string | null | undefined, decoration: TextDecoration): string {
  const current = getTextDecorationState(currentValue);
  return textDecorationClassForState(
    decoration === 'underline' ? !current.underline : current.underline,
    decoration === 'line-through' ? !current.strikethrough : current.strikethrough,
  );
}
